module.exports = __webpack_public_path__ + "static/img/picture2.4d6d2ffa.png";